import { render, staticRenderFns } from "./CreateWorkflow.vue?vue&type=template&id=b5df6c1c"
import script from "./CreateWorkflow.vue?vue&type=script&lang=js"
export * from "./CreateWorkflow.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CreateWorkflow.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports